export default __webpack_public_path__ + "static/media/compliance-2020.6a295ece.jpg";